var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supervision-empty"},[_c('div',{staticClass:"img-bg"}),_c('div',{staticClass:"empty-text",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }